// シンプルなlocalStorageベースのテナント保存（Phase 1）
const KEY = 'bcart-hub-tenant-id';

export const tenantStore = {
  get(): string | null {
    return localStorage.getItem(KEY);
  },
  set(id: string): void {
    localStorage.setItem(KEY, id);
  },
  clear(): void {
    localStorage.removeItem(KEY);
  },
};
